// ----------------------- REDUX CONSTANTS -----------------

export const CAMPAIGN_PREFIX = 'campaign/';

export const SET_SELECTED_CAMPAIGN = `${CAMPAIGN_PREFIX}SET_SELECTED_CHALLENGE`;

export const SET_SELECTED_CAMPAIGN_ID = `${CAMPAIGN_PREFIX}SET_SELECTED_CHALLENGE_ID`;

export const SET_SELECTED_SEGMENT = `${CAMPAIGN_PREFIX}SET_SELECTED_SEGMENT`;

export const TOP_CONTRIBUTORS_REQUESTED = `${CAMPAIGN_PREFIX}TOP_CONTRIBUTORS_REQUESTED`;

export const TOP_CONTRIBUTORS_SUCCEEDED = `${CAMPAIGN_PREFIX}TOP_CONTRIBUTORS_SUCCEEDED`;

export const TOP_CONTRIBUTORS_FAILED = `${CAMPAIGN_PREFIX}TOP_CONTRIBUTORS_FAILED`;

export const TOP_TAGS_REQUESTED = `${CAMPAIGN_PREFIX}TOP_TAGS_REQUESTED`;

export const TOP_TAGS_SUCCEEDED = `${CAMPAIGN_PREFIX}TOP_TAGS_SUCCEEDED`;

export const TOP_TAGS_FAILED = `${CAMPAIGN_PREFIX}TOP_TAGS_FAILED`;

// Impact card actions
export const IMPACT_FILTER_REQUESTED = `${CAMPAIGN_PREFIX}IMPACT_FILTER_REQUESTED`;

export const IMPACT_FILTER_SUCCEEDED = `${CAMPAIGN_PREFIX}IMPACT_FILTER_SUCCEEDED`;

export const IMPACT_FILTER_FAILED = `${CAMPAIGN_PREFIX}IMPACT_FILTER_FAILED`;

export const SPECIFIC_CAMPAIGN_REQUESTED = `${CAMPAIGN_PREFIX}SPECIFIC_CHALLENGE_REQUESTED`;

export const SPECIFIC_CAMPAIGN_SUCCEEDED = `${CAMPAIGN_PREFIX}SPECIFIC_CHALLENGE_SUCCEEDED`;

export const SPECIFIC_CAMPAIGN_FAILED = `${CAMPAIGN_PREFIX}SPECIFIC_CHALLENGE_FAILED`;

export const CONNECTED_CAMPAIGN_REQUESTED = `${CAMPAIGN_PREFIX}CONNECTED_CHALLENGE_REQUESTED`;

export const CONNECTED_CAMPAIGN_SUCCEEDED = `${CAMPAIGN_PREFIX}CONNECTED_CHALLENGE_SUCCEEDED`;

export const CONNECTED_CAMPAIGN_FAILED = `${CAMPAIGN_PREFIX}CONNECTED_CHALLENGE_FAILED`;

export const SET_PARENT_CAMPAIGN = `${CAMPAIGN_PREFIX}SET_PARENT_CHALLENGE`;
